import {
    GET_SUBADMIN,
    GET_SUBADMIN_SUCCESS,
    GET_SUBADMIN_FAILURE,
    CREATE_PERMISSION,
    CREATE_PERMISSION_SUCCESS,
    CREATE_PERMISSION_FAILURE,
    UPDATE_PERMISSION,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_FAILURE,
    UPDATE_SUBADMIN_SUCCESS,
    UPDATE_SUBADMIN,
    UPDATE_SUBADMIN_FAILURE,
    VIEW_SUBADMIN,
    VIEW_SUBADMIN_SUCCESS,
    VIEW_SUBADMIN_FAILURE
  } from "../../Actions/types";
  
  const initialState = {
    getLoader: false,
    getError: null,
    getData: null,
    createLoader: false,
    createData: null,
    createError: null,
    editLoader: false,
    editData: null,
    editError: null,
    editAdminLoader:null,
    editAdminData:null,
    viewloader:null,
    viewdata:null,
    viewerror:null,
    editSubadminError:null
  };
  function PermissionReducer(state = initialState, action) {
    switch (action.type) {
      case GET_SUBADMIN:
        return { ...state, getLoader: true };
      case GET_SUBADMIN_SUCCESS:
        return { ...state, getData: action?.payload, getLoader: false };
      case GET_SUBADMIN_FAILURE:
        return { ...state, getError: true, getLoader: false };

        case UPDATE_SUBADMIN:
        return { ...state, editAdminLoader: true };
  
      case UPDATE_SUBADMIN_SUCCESS:
        return {
          ...state,
          editAdminData: action?.payload || null,
          editLoader: false,
          editSubadminError: false,
        };
      case UPDATE_SUBADMIN_FAILURE:
        return {
          ...state,
          editSubadminError: true,
          editLoader: false,
          editAdminData: null,
        };
      case UPDATE_PERMISSION:
        return { ...state, editLoader: true };
  
      case UPDATE_PERMISSION_SUCCESS:
        return {
          ...state,
          editData: action?.payload || null,
          editLoader: false,
          editError: false,
        };
      case UPDATE_PERMISSION_FAILURE:
        return {
          ...state,
          editError: true,
          editLoader: false,
          editData: null,
        };
      case CREATE_PERMISSION:
        return { ...state, createLoader: true };
      case CREATE_PERMISSION_SUCCESS:
        return {
          ...state,
          createData: action?.payload,
          createLoader: false,
        };
      case CREATE_PERMISSION_FAILURE:
        return {
          ...state,
          createError: true,
          createLoader: false,
        };
        case VIEW_SUBADMIN:
      return {
        ...state,
        viewloader: true,
      };
    case VIEW_SUBADMIN_SUCCESS:
      return {
        ...state,
        viewdata: action?.payload,
        viewloader: false,
      };
    case VIEW_SUBADMIN_FAILURE:
      return {
        ...state,
        viewerror: true,
        viewloader: false,
      };
      default:
        return state;
    }
  }
  
  export default PermissionReducer;
  